(function () {
  'use strict';

  angular
    .module('specsguardApp')
    .component('sgFormWithInfo', {
      templateUrl: 'app-legacy/components/sg-form-with-info/sg-form-with-info.html',

      bindings: {
        /**
         * @param targetObj {Object} - The object which is the ng-model for fieldsObj
         * */
        targetObj: '=',
        /* eslint-disable max-len */
        /**
         * @param fieldsObj {Object} - Object containing all fields to be rendered in the form. Each key represents a
         *                             field in the form
         * @param fieldsObj[key] {Object} - Object with configuration how the field in the form should be rendered
         *
         * TODO required does not work yet on image picker.
         * If ever needed, make an sg-imagepicker directive and follow this:
         * https://medium.com/@pugillum/creating-a-custom-form-field-with-validation-using-angularjs-1-5-and-typescript-ece9c6c3168f
         *
         * @param fieldsObj[key].fieldType {String} - Enum: ['input', 'dropdown', 'checkbox', 'imagepicker']
         * @param fieldsObj[key].label {String}
         * @param [fieldsObj[key].postfix] {String} - String postfixed to the input
         * @param fieldsObj[key].required {Boolean}
         * NOTE: we cannot directly call fieldsObj[key].onChange due to binding '=' in stead of '&'
         * @param [fieldsObj[key].onChange] {Function} - cb for when select item changes.
         *                                               Will be called with one object as param wit these keys:
         *                                               value, item, key, form
         * @param fieldsObj[key].options {Array} - Array of objects for 'dropdown', 'checkbox' and 'imagepicker'
         * @param fieldsObj[key].filter - Filter to use, see buildingAddDataService and sgAutocompleteHelpers.filter
         * @param [fieldsObj[key].optionsMapping.displayNameKey]
         * @param [fieldsObj[key].optionsMapping.valueKey]
         * @param [fieldsObj[key].validationErrors {Object} - Object with various keys that represent error texts for
         *                             $scope.infoForm[key].$error.
         *                             Good to know: if used in conjunction with [fieldsObj[key].attributes:
         *                             used the normalized attribute name in validationErrors.
         *                             For example: validationErrors.pattern & attributes['ng-pattern']
         *
         * @param [fieldsObj[key].helpKey {String} - Key to show help icon (see sg-help)
         * @param [fieldsObj[key].multi {Boolean} - When using imagepicker, this determines if multiple images
         *                                          can be selected. Defaults to false
         * @param [fieldsObj[key].attributes {Object} - Object with various keys to add additional html attributes
         *                                              (it uses the sgHtmlAttributes directive)
         * */
        /* eslint-enable max-len */
        fieldsObj: '=',
        /**
         * @param [infoObj] {Object} - Can be omitted to just show a form
         * @param infoObj.title {String}
         * @param infoObj.targetObjKey {String} - eg. targetObj['buildingTemplate']
         * @param infoObj.targetObjInfoKey {String} - eg targetObj['buildingTemplate']['info']
         * @param infoObj.chips {Object} - Optional obj to determine if a chips section should be shown
         * @param infoObj.chips.label {String} - Label for the chips section
         * @param infoObj.chips.items {Array} - Container of chips
         * @oaram infoObj.chips.items.label {String} - Label of each chip
         * */
        infoObj: '=',
        /**
         * @param buttons {Array}
         * @param buttons[n] {Object}
         * @param buttons[n].label {String}
         * @param buttons[n].type {String} - button type eg. 'submit'
         * @param buttons[n].validateForm {Boolean} - disable the button if the form is invalid
         * */
        buttons: '=',
        /**
         * @param buttonsCb {Function}
         * - callback when a button is clicked. It has index as argument so it can be handled in parent controller
         * when using multiple buttons
         * */
        buttonsCb: '&',
        /**
         * @param form {Object} - form to couple to parent controller
         * */
        form: '=',
        labels: '='
      },
      //bindToController: true,
      controllerAs: '$sgFormWithInfoCtrl',
      controller: 'sgFormWithInfoController'
    });


})();
